/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { IGetEstimateResponse, IPlace } from "../../functions/src/api/placeInterface";
import { IApi } from "../api/api";

import "./estimateDetails.scss";

interface IProps {
    api: IApi;
    place: IPlace | "LOADING" | undefined;
}

interface IState {
    getEstimateResponse: IGetEstimateResponse | undefined;
}

export class EstimateDetails extends React.PureComponent<IProps, IState> {
    public state: IState = {
        getEstimateResponse: undefined,
    };

    public render() {
        return (
            <div className="scpr-EstimateDetails">
                {this.renderPrice()}
            </div>
        );
    }

    public componentDidMount() {
        const { place } = this.props;
        if (place != null && place !== "LOADING") {
            this.getEstimate(place);
        }
    }

    public componentDidUpdate(prevProps: IProps) {
        const { place } = this.props;
        const { place: prevPlace } = prevProps;

        if (place == null || place === "LOADING") {
            if (prevPlace != null && prevPlace !== "LOADING") {
                this.setState({ getEstimateResponse: undefined });
            }

            return;
        }

        if (prevPlace == null || prevPlace === "LOADING" || place.place_id !== prevPlace.place_id) {
            this.setState({ getEstimateResponse: undefined });
            this.getEstimate(place);
        }
    }

    private renderPrice() {
        const { getEstimateResponse } = this.state;

        if (getEstimateResponse == null) {
            return "// TODO Loading";
        }

        const { estimatedPrice, lotAcreage } = getEstimateResponse;
        return (
            <>
                <span className="scpr-EstimateDetails-acreage">Property size: {lotAcreage} acres</span>
                <span className="scpr-EstimateDetails-price">Estimate: ${estimatedPrice}</span>
            </>
        );
    }

    private getEstimate = (place: IPlace) => {
        const { api } = this.props;
        api.placeService.getEstimate(place).then((getEstimateResponse) => {
            this.setState({ getEstimateResponse });
        });
    };
}
